import { useEffect, useState } from "react";

import { toast, ToastContainer } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import useUpdateVehicleData from "../dataFetch/addVehicle";
import FilterComponent from "./FilterComponent";
const availableShifts = ["5 AM - 12PM", "8 AM - 2 PM", "2 PM - 8PM"];

export default function ViewVehicle({ city }: { city: string }) {
  const navigate = useNavigate();
  const params: any = useParams();
  const id: string = params.id || "";
  const { updateVehicle, getVehicleDetails, getClusterList, getTspList } = useUpdateVehicleData();

  const [initialLoadDone, setInitialLoadDone] = useState(false);
  const [vehicleData, setVehicleData] = useState<any>({});
  const [filterType, setFilterType] = useState<"cluster" | "tsp" | null>(null);
  const [openFilter, setOpenFilter] = useState<boolean>(false);
  const [selectedCluster, setSelectedCluster] = useState<any[]>([]);
  const [selectedTsp, setSelectedTsp] = useState<any[]>([]);

  useEffect(() => {
    getVehicleData();
  }, [id]);


  const handleBack = (e: any) => {
    e.preventDefault();
    navigate(-1);
  };

  const getVehicleData = async () => {
    console.log("🔄 Fetching vehicle details for ID:", id);
    const vehicleDetails = await getVehicleDetails({ id });
  
    console.log("✅ Vehicle Details from API:", vehicleDetails);
  
    setVehicleData(vehicleDetails); // update the state
    handleInitialDataLoad(vehicleDetails); // pass fresh data directly
  };
 
  

  // useEffect(() => {
  //   console.log("✅ vehicleData updated:", vehicleData);
  // }, [vehicleData]);
  

  const handleInitialDataLoad = async (data: any) => {
    console.log("📦 Handling initial data load with:", data);
  
    const allClusterList = await getClusterList({ city });
    const cluster = allClusterList.map((item: any) => ({
      clusterDDN: item.clusterDDN,
      isChecked: data?.clustermapped?.some(
        (mapped: any) => mapped.clusterDDN === item.clusterDDN && mapped.isChecked
      ) || false,
    }));
  
    const allTspList = await getTspList({ city });
    const tsp = allTspList.map((item: any) => ({
      DDNNumber: item.DDNNumber,
      isChecked: data?.tspmapped?.some(
        (mapped: any) => mapped.DDNNumber === item.DDNNumber && mapped.isChecked
      ) || false,
    }));
  
    console.log("✅ Final Cluster to Set", cluster);
    console.log("✅ Final TSP to Set", tsp);
  
    setSelectedCluster(cluster);
    setSelectedTsp(tsp);
  };
  
  const handleUpdateButton = async (e: any) => {
    e.preventDefault();
    const body: any = {
      vehicleNo: e.target.vehicleNo.value,
      fuelCapacity: e.target.fuelCapacity.value,
      mileage: e.target.mileage.value,
      wardNumber: e.target.ward.value,
      shift: e.target.shift.value,
      city: e.target.city.value,
      driverId: e.target.driverId.value,
      driverHelperID: e.target.driverHelperId.value,
      clustermapped: selectedCluster,
      tspmapped: selectedTsp,
    };
    const response = await updateVehicle(id, JSON.stringify(body));
    toast(response.message, { type: "success", theme: "colored" });
    navigate(-1);
  };

  // const handleFilter = (e: any) => {
  //   e.preventDefault();
  //   setOpenFilter(true);
  // };

  const handleFilter = (type: "cluster" | "tsp") => {
    setOpenFilter(true);
    setFilterType(type);
  };

  return (
    <>
      <div className="m-20">
        <form className="w-full mt-8" onSubmit={handleUpdateButton}>
          {/* --- City and Vehicle Number --- */}
          <div className="flex flex-wrap -mx-3 mb-6">
            <div className="w-full md:w-1/2 px-3">
              <label className="block uppercase text-gray-700 text-xs font-bold mb-2">City</label>
              <input
                className="block w-full bg-recity text-white rounded py-3 px-4 mb-3"
                disabled
                type="text"
                name="city"
                defaultValue={city}
              />
            </div>
            <div className="w-full md:w-1/2 px-3">
              <label className="block uppercase text-gray-700 text-xs font-bold mb-2">Vehicle Number</label>
              <input
                className="block w-full bg-lightBlue text-gray-700 uppercase rounded py-3 px-4 mb-3"
                name="vehicleNo"
                type="text"
                defaultValue={vehicleData?.vehicleNo}
              />
            </div>
          </div>

          {/* --- Fuel and Mileage --- */}
          <div className="flex flex-wrap -mx-3 mb-6">
            <div className="w-full md:w-1/2 px-3">
              <label className="block uppercase text-gray-700 text-xs font-bold mb-2">Fuel Capacity</label>
              <input
                className="block w-full bg-lightBlue text-gray-700 rounded py-3 px-4"
                name="fuelCapacity"
                type="number"
                defaultValue={vehicleData?.fuelCapacity}
              />
            </div>
            <div className="w-full md:w-1/2 px-3">
              <label className="block uppercase text-gray-700 text-xs font-bold mb-2">Mileage</label>
              <input
                className="block w-full bg-lightBlue text-gray-700 rounded py-3 px-4"
                name="mileage"
                type="number"
                defaultValue={vehicleData?.mileage}
              />
            </div>
          </div>

          {/* --- Ward and Shift --- */}
          <div className="flex flex-wrap -mx-3 mb-6">
            <div className="w-full md:w-1/2 px-3">
              <label className="block uppercase text-gray-700 text-xs font-bold mb-2">Ward</label>
              <input
                className="block w-full bg-lightBlue text-gray-700 rounded py-3 px-4"
                name="ward"
                type="text"
                defaultValue={vehicleData?.ward}
              />
            </div>
            <div className="w-full md:w-1/2 px-3">
              <label className="block uppercase text-gray-700 text-xs font-bold mb-2">Shift</label>
              <select
                className="block w-full bg-lightBlue text-gray-700 py-3 px-4 rounded"
                name="shift"
                defaultValue={vehicleData?.shift}
              >
                {availableShifts.map((shift, idx) => (
                  <option key={idx}>{shift}</option>
                ))}
              </select>
            </div>
          </div>

          {/* --- Driver IDs --- */}
          <div className="flex flex-wrap -mx-3 mb-6">
            <div className="w-full md:w-1/2 px-3">
              <label className="block uppercase text-gray-700 text-xs font-bold mb-2">Driver ID</label>
              <input
                className="block w-full bg-lightBlue text-gray-700 rounded py-3 px-4"
                name="driverId"
                type="text"
                defaultValue={vehicleData?.driverId}
              />
            </div>
            <div className="w-full md:w-1/2 px-3">
              <label className="block uppercase text-gray-700 text-xs font-bold mb-2">Driver Helper ID</label>
              <input
                className="block w-full bg-lightBlue text-gray-700 rounded py-3 px-4"
                name="driverHelperId"
                type="text"
                defaultValue={vehicleData?.driverHelperID}
              />
            </div>
          </div>

          {/* --- Cluster Section --- */}
          <div className="flex flex-wrap -mx-3 mb-6">
            <div className="w-full md:w-1/2 px-3">
              <label className="block uppercase text-gray-700 text-xs font-bold mb-2">Cluster Mapped</label>
              <div className="grid grid-cols-3 gap-2">
                {selectedCluster?.map((cluster, idx) =>
                  cluster.isChecked ? (
                    <div key={idx} className="bg-lightBlue p-1 rounded text-sm text-white">
                      {cluster.clusterDDN}
                    </div>
                  ) : null
                )}
              </div>
            </div>
            <div className="w-full md:w-1/2 px-3">
              <button
                className="block w-full bg-recity text-white rounded py-3 px-4"
                onClick={(e) => { e.preventDefault();handleFilter("cluster"); }}
              >
                Manage Clusters
              </button>
            </div>
          </div>

          {/* --- Tsp Section --- */}
          <div className="flex flex-wrap -mx-3 mb-6">
            <div className="w-full md:w-1/2 px-3">
              <label className="block uppercase text-gray-700 text-xs font-bold mb-2">Tsp Mapped</label>
              <div className="grid grid-cols-3 gap-2">
                {selectedTsp?.map((tsp, idx) =>
                  tsp.isChecked ? (
                    <div key={idx} className="bg-lightBlue p-1 rounded text-sm text-white">
                      {tsp.DDNNumber}
                    </div>
                  ) : null
                )}
              </div>
            </div>
            <div className="w-full md:w-1/2 px-3">
              <button
                className="block w-full bg-recity text-white rounded py-3 px-4"
                onClick={(e) => { e.preventDefault();handleFilter("tsp"); }}
              >
                Manage Tsp
              </button>
            </div>
          </div>

          {/* --- Submit Buttons --- */}
          <div className="flex justify-center">
            <button className="bg-green p-4 m-4 text-white rounded uppercase" type="submit">
              Update Vehicle
            </button>
            <button className="bg-recity p-4 m-4 text-white rounded uppercase" onClick={handleBack}>
              Back
            </button>
          </div>
        </form>
      </div>

      {openFilter && filterType === "cluster" && (
        <FilterComponent
          openFilter={openFilter}
          setOpenFilter={setOpenFilter}
          selectedItems={selectedCluster}
          setSelectedItems={setSelectedCluster}
          labelKey="clusterDDN"
          title="Clusters"
        />
      )}

      {openFilter && filterType === "tsp" && (
        <FilterComponent
          openFilter={openFilter}
          setOpenFilter={setOpenFilter}
          selectedItems={selectedTsp}
          setSelectedItems={setSelectedTsp}
          labelKey="DDNNumber"
          title="TSPs"
        />
      )}


      <ToastContainer />
    </>
  );
}
